var React = require('react');

function Document (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"MOBILE","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"1.3.2-Menu","transform":"translate(-24.000000, -195.000000)","fill":"#006A35","fillRule":"nonzero"},React.createElement("g",{"id":"Group-10","transform":"translate(24.000000, 195.000000)"},[React.createElement("path",{"d":"M1,1 L1,19.8095238 L18,19.8095238 L18,1 L1,1 Z M0,0 L19,0 L19,20.8095238 L0,20.8095238 L0,0 Z","id":"Rectangle-9","key":0}),React.createElement("polygon",{"id":"Line-2","points":"2.66666667 5.47619048 2.66666667 4.47619048 16.3333333 4.47619048 16.3333333 5.47619048","key":1}),React.createElement("polygon",{"id":"Line-2-Copy","points":"2.66666667 9.0952381 2.66666667 8.0952381 16.3333333 8.0952381 16.3333333 9.0952381","key":2}),React.createElement("polygon",{"id":"Line-2-Copy-2","points":"2.66666667 12.7142857 2.66666667 11.7142857 16.3333333 11.7142857 16.3333333 12.7142857","key":3}),React.createElement("polygon",{"id":"Line-2-Copy-3","points":"2.66666667 16.3333333 2.66666667 15.3333333 16.3333333 15.3333333 16.3333333 16.3333333","key":4})]))));
}

Document.defaultProps = {"width":"19px","height":"21px","viewBox":"0 0 19 21","version":"1.1"};

module.exports = Document;

Document.default = Document;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/document.svg
// module id = 1477
// module chunks = 0